import _import from './config'
export default {
    path: 'carved',
    component: {
        template: '<router-view :key="$route.fullPath"/>'
    },
    name: 'carved',
    redirect: '/carved/timetable',
    children: [
        {
            path: 'timetable',
            component: _import('finecarved/timetable'),
            name: 'timetable',
            meta: {
                auth: true
            }
        }, {
            path: 'pushrecord',
            component: _import('finecarved/pushrecord'),
            name: 'pushrecord',
            meta: {
                auth: true
            }
        }, {
            path: 'student',
            component: _import('finecarved/student'),
            name: 'carvedstudent',
            meta: {
                auth: true
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/finecarved.js